/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UploadDocumentResponse } from '../models/UploadDocumentResponse';
import type { UploadImageResponse } from '../models/UploadImageResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UploadsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Upload a generic image
     * Generic image upload endpoint reusable by any feature. Accepts a single file as multipart/form-data under the "file" field and an optional "folder" query parameter to organize the object in Firebase Storage. The image is automatically preprocessed before being stored: it is auto-rotated from EXIF orientation, resized to fit within 2048px on the longest side, and re-encoded as WebP with a target size of ~500KB (quality is iteratively reduced and dimensions are lowered as a fallback if needed). Returns the public URL of the optimized image along with its final dimensions, MIME type and size. Use this endpoint when you need an image URL before associating it with a domain entity (e.g. before creating a neighboring report).
     * @returns UploadImageResponse Image uploaded and optimized successfully.
     * @throws ApiError
     */
    public uploadControllerUploadImage({
        formData,
        folder = 'misc',
        isPublic,
    }: {
        formData: {
            /**
             * Image file to upload (JPG, PNG, WebP or HEIC, max 15MB raw). The image is automatically compressed to roughly 500KB and re-encoded as WebP.
             */
            file: Blob;
        },
        /**
         * Folder prefix inside the storage bucket (e.g. "neighboring-reports"). Defaults to "misc".
         */
        folder?: string,
        /**
         * Whether the uploaded image should be publicly accessible without authentication tokens. When true, returns a permanent public URL (storage.googleapis.com). When false, returns a token-based URL that may expire. Defaults to the server-level FIREBASE_STORAGE_PUBLIC setting.
         */
        isPublic?: boolean,
    }): CancelablePromise<UploadImageResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/uploads/images',
            query: {
                'folder': folder,
                'isPublic': isPublic,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `No file uploaded, invalid MIME type, file too large, or the image could not be processed.`,
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Upload a document (PDF, JPG, PNG)
     * Secure document upload endpoint. Validates file type via magic bytes (not just extension/MIME), rejects PDFs containing JavaScript/Launch/EmbeddedFile/XFA, enforces 10MB limit, and stores files privately. Returns a URL to use in CreateSocietyDto or other document fields.
     * @returns UploadDocumentResponse Document uploaded successfully.
     * @throws ApiError
     */
    public uploadControllerUploadDocument({
        formData,
        folder = 'misc',
        isPublic,
    }: {
        formData: {
            /**
             * Document file to upload (PDF, JPG, PNG — max 10MB). PDFs are validated for dangerous content.
             */
            file: Blob;
        },
        /**
         * Folder prefix inside the storage bucket. Only letters, numbers, dashes and underscores.
         */
        folder?: string,
        /**
         * Whether the uploaded image should be publicly accessible without authentication tokens. When true, returns a permanent public URL (storage.googleapis.com). When false, returns a token-based URL that may expire. Defaults to the server-level FIREBASE_STORAGE_PUBLIC setting.
         */
        isPublic?: boolean,
    }): CancelablePromise<UploadDocumentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/uploads/documents',
            query: {
                'folder': folder,
                'isPublic': isPublic,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `No file uploaded, invalid file type, file too large, or PDF contains forbidden elements.`,
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
            },
        });
    }
}
